import { Overline } from "@/components/landing/Shared";

const SECTIONS = [
  {
    title: "Information We Collect",
    subs: [
      {
        heading: "Information You Provide",
        paragraphs: ["When you submit an inquiry or lead form, we may collect information such as:"],
        bullets: [
          "First and last name",
          "Email address",
          "Telephone/mobile phone number",
          "State and ZIP code",
          "Information relating to the campaign or matter you select",
          "Information you provide in qualification questions",
          "Any additional information you voluntarily submit through the Website",
        ],
        after: "You are not required to provide information unless it is necessary for the particular inquiry or service you are requesting. If you do not provide certain information, we may be unable to process or respond to your inquiry.",
      },
      {
        heading: "Information Collected Automatically",
        paragraphs: [
          "When you access the Website, we may send one or more cookies to your computer. We use these cookies to identify prior users and to track usage of the Website. You can remove cookies and modify your browser's settings at any time to accept all cookies, reject all cookies, or notify you when a cookie is sent.",
          "We may also automatically record certain information from your system, including:",
        ],
        bullets: [
          "IP address",
          "A unique device or user ID",
          "Version of software installed and system type",
          "Browser type and version",
          "Operating system and device information",
          "The content and pages you access on the Website",
          "The dates and times of your visits",
          "Referring website or URL",
          "General interaction and usage information",
        ],
        after: "We use this information for analytical purposes and to help us improve the Website and our business in general. We may provide this information to affiliates and/or third parties that assist us in improving these functions.",
      },
      {
        heading: "Lead and Consent Information",
        paragraphs: ["When you submit an inquiry, we may also maintain records relating to that submission, including:"],
        bullets: [
          "The date and time of submission",
          "The campaign or matter selected",
          "The consent/disclosure presented to you",
          "The consent version applicable at the time of submission",
          "Your consent status",
          "The Website or source through which the inquiry was submitted",
          "IP address and other technical information",
          "Records relating to the submission and its processing",
          "TrustedForm certificate information or similar lead-consent verification information, where applicable",
        ],
        after: "These records may be maintained to document the inquiry, consent, submission, and processing of a lead.",
      },
    ],
  },
  {
    title: "How We Use Information",
    paragraphs: ["Lawsuit Settlement Help only collects personally identifiable information that is voluntarily provided to us by users. We may use information we collect for purposes including:"],
    bullets: [
      "Processing and responding to inquiries submitted through the Website",
      "Determining whether an inquiry may qualify for a particular campaign",
      "Connecting or referring an inquiry to an appropriate third party",
      "Providing information to lead buyers, intake providers, legal professionals, law firms, or other parties involved in responding to or evaluating an inquiry",
      "Facilitating communications relating to an inquiry",
      "Contacting you by telephone, SMS/text message, email, direct mail, or other communication methods where permitted and consistent with the consent and disclosures provided at the time of submission",
      "Presenting you with promotions, advertisements, and opportunities that may be of interest to you",
      "Administrative and authentication purposes, and to properly operate, maintain, and provide the features and functionality of the Website",
      "Enabling our affiliates and contracted third parties to assist us in operating, maintaining, and providing our services",
      "Carrying out our obligations arising from any agreements entered into with you",
      "Notifying you about changes to this Privacy Policy, the Disclaimer, the Website, or our services",
      "Maintaining records of consent and lead submissions",
      "Investigating and helping to prevent potentially unlawful activities, fraud, or violations of this Privacy Policy, and enforcing or applying our rights",
      "Operating, maintaining, securing, and improving the Website",
      "Improving the quality and design of the Website and creating new features, promotions, functionality, and services by storing, tracking, and analyzing preferences and trends",
      "Measuring and analyzing Website and marketing performance",
      "Complying with applicable laws, regulations, legal processes, and requests from governmental authorities",
      "Protecting the rights, property, and safety of our users, clients, and others",
      "Marketing and business purposes",
      "Performing other purposes disclosed at the time information is collected or otherwise permitted by applicable law",
    ],
  },
  {
    title: "How We Share Information",
    paragraphs: [
      "Lawsuit Settlement Help reserves the right to rent, sell, share, or transfer your personal information to third parties for any legally permissible purpose.",
      "We may share information collected through the Website with third parties as necessary to process, evaluate, route, or respond to your inquiry.",
      "Depending on the campaign and the information you provide, recipients may include:",
    ],
    bullets: [
      "Lead buyers",
      "Intake providers",
      "Law firms and legal professionals",
      "Service providers that assist with lead processing, communications, technology, hosting, analytics, security, or business operations",
      "Businesses involved in processing or responding to inquiries",
      "Government authorities, courts, regulators, or other parties when required or permitted by law",
    ],
    after: [
      "The parties receiving an inquiry may vary depending on the campaign, eligibility criteria, geographic location, and other factors relevant to the inquiry.",
      "Once information is provided to a third party, that third party may handle the information according to its own privacy policy and practices.",
      "We may also disclose information when reasonably necessary to comply with law, respond to legal process, protect our rights or property, investigate fraud or abuse, protect the safety of individuals, or in connection with a corporate transaction such as a merger, acquisition, restructuring, financing, or sale of assets.",
    ],
  },
  {
    title: "Communications",
    paragraphs: [
      "If you submit an inquiry and provide consent to be contacted, you may receive communications relating to your inquiry from parties authorized to contact you based on the applicable campaign and consent.",
      "Communications may include telephone calls, SMS/text messages, emails, or other communications, subject to applicable law and the disclosures and consent presented when you submitted your information.",
    ],
  },
  {
    title: "TrustedForm and Lead Verification",
    paragraphs: [
      "We may use third-party lead verification and consent-recording technologies, including TrustedForm or similar services, to document information about the submission of an inquiry and the consent experience.",
      "These technologies may record information about your interaction with the Website, including the page visited, form interaction, submission event, technical information, and consent disclosure presented during the session.",
      "The resulting certificate or verification record may be provided to parties receiving or processing the lead for purposes including verifying the source, submission, and consent associated with the inquiry.",
    ],
  },
  {
    title: "Cookies and Similar Technologies",
    paragraphs: ["We may use cookies and similar technologies to:"],
    bullets: [
      "Operate essential Website functionality",
      "Maintain security",
      "Detect fraud or abuse",
      "Understand Website usage",
      "Measure marketing and advertising performance",
      "Improve Website functionality and performance",
    ],
    after: [
      "You may be able to control cookies through your browser settings. Disabling certain technologies may affect portions of the Website.",
      "Third-party services used on the Website may also use cookies or similar technologies according to their own policies.",
    ],
  },
  {
    title: "Third-Party Websites and Services",
    paragraphs: [
      "The Website may contain links to third-party websites or services.",
      "We do not control the privacy practices of third-party websites, lead recipients, law firms, intake providers, buyers, or other organizations. Their handling of your information may be governed by their own privacy policies and terms.",
      "We encourage you to review the privacy policies of any third party that contacts you or with whom you interact.",
    ],
  },
  {
    title: "Information Security",
    paragraphs: [
      "We use reasonable administrative, technical, and organizational measures designed to protect information under our control against unauthorized access, use, alteration, or disclosure.",
      "However, no method of transmission over the Internet and no electronic storage system can be guaranteed to be completely secure.",
    ],
  },
  {
    title: "Information Retention",
    paragraphs: ["We may retain information for as long as reasonably necessary to:"],
    bullets: [
      "Provide or facilitate the services and processing associated with an inquiry",
      "Maintain business and transaction records",
      "Document consent and lead submissions",
      "Comply with legal, regulatory, contractual, or reporting obligations",
      "Resolve disputes",
      "Prevent fraud or abuse",
      "Enforce agreements",
      "Protect our legal rights and business interests",
    ],
    after: ["Retention periods may vary depending on the nature of the information and the applicable legal or business requirements."],
  },
  {
    title: "Your Privacy Choices and Rights",
    paragraphs: [
      "Depending on where you live and applicable law, you may have rights concerning your personal information, which may include rights to request access to, correction of, deletion of, or information about the processing of your personal information.",
      "You may also have rights concerning certain communications or marketing activities.",
      "To make a privacy-related request, please use the contact information made available on the Website.",
      "We may need to verify your identity before completing certain requests.",
      "Nothing in this Privacy Policy limits rights you may have under applicable law.",
    ],
  },
  {
    title: "Children's Information",
    paragraphs: [
      "The Website is not directed toward children, and we do not knowingly seek to collect personal information from children under the age required by applicable law.",
      "If you believe that a child has provided personal information through the Website, please contact us through the contact information made available on the Website so that we can evaluate and take appropriate action.",
    ],
  },
  {
    title: "Opting Out",
    paragraphs: [
      "Lawsuit Settlement Help only collects personally identifiable information that is voluntarily provided to us by users. You may decline to provide personal information to us and/or refuse cookies through your browser settings.",
      "Should you no longer wish to receive promotional communications, you may opt out by following the instructions included in each communication or by contacting us through the contact information made available on the Website. You may continue to receive communications from us for up to ten business days from the time we receive your unsubscribe request.",
      "Please note that Lawsuit Settlement Help can only control its own mailing lists and policies. Third-party advertisers that maintain their own mailing lists may send communications that advertise our services, and you may need to contact those parties directly to stop receiving their communications.",
    ],
  },
  {
    title: "Changes to This Privacy Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time.",
      "When we make changes, we may update the Effective Date shown at the beginning of this Privacy Policy. Your continued use of the Website after an updated Privacy Policy is posted will be subject to the updated policy to the extent permitted by applicable law.",
    ],
  },
  {
    title: "Contact Us",
    paragraphs: ["If you have questions about this Privacy Policy or our privacy practices, please use the contact information made available on the Website."],
  },
];

const PREAMBLE = [
  "Please be advised that your use of Lawsuit Settlement Help and any personal information you provide through this website, including lawsuitsettlementhelp.com (the “Website”), are subject at all times to the following Privacy Policy. By using the Website, you accept this Privacy Policy.",
  "This Privacy Policy describes the information we collect when you visit the Website, submit an inquiry or lead form, communicate with us, or otherwise interact with the Website, and how that information may be used and shared.",
];

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-policy-page" className="min-h-screen bg-[#FBF9F5] text-[#1A1715]">
      <div className="mx-auto max-w-3xl px-5 sm:px-10 py-20 sm:py-28">
        <Overline>Legal</Overline>
        <h1 className="mt-4 font-serif font-semibold text-4xl sm:text-5xl tracking-tight">
          Privacy Policy
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#78716C]">
          Effective Date: August 20, 2026 · lawsuitsettlementhelp.com
        </p>
        <div className="mt-8 space-y-4">
          {PREAMBLE.map((p) => (
            <p key={p.slice(0, 24)} className="font-news text-base text-[#44403C] leading-relaxed">
              {p}
            </p>
          ))}
        </div>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <section key={s.title}>
              <h2 className="font-serif font-semibold text-2xl">
                <span className="font-serif italic text-[#B45309]/50 mr-3">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.title}
              </h2>
              {s.paragraphs?.map((p) => (
                <p key={p.slice(0, 24)} className="mt-3 font-news text-base text-[#44403C] leading-relaxed">
                  {p}
                </p>
              ))}
              {s.bullets && (
                <ul className="mt-3 space-y-1.5">
                  {s.bullets.map((b) => (
                    <li key={b.slice(0, 24)} className="flex gap-3 font-news text-base text-[#44403C] leading-relaxed">
                      <span className="text-[#C2410C] shrink-0">·</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
              {(Array.isArray(s.after) ? s.after : s.after ? [s.after] : []).map((p) => (
                <p key={p.slice(0, 24)} className="mt-3 font-news text-base text-[#44403C] leading-relaxed">
                  {p}
                </p>
              ))}
              {s.subs?.map((sub) => (
                <div key={sub.heading} className="mt-5">
                  <h3 className="font-serif font-semibold text-lg text-[#1A1715]">
                    {sub.heading}
                  </h3>
                  {sub.paragraphs?.map((p) => (
                    <p key={p.slice(0, 24)} className="mt-2.5 font-news text-base text-[#44403C] leading-relaxed">
                      {p}
                    </p>
                  ))}
                  {sub.bullets && (
                    <ul className="mt-2.5 space-y-1.5">
                      {sub.bullets.map((b) => (
                        <li key={b.slice(0, 24)} className="flex gap-3 font-news text-base text-[#44403C] leading-relaxed">
                          <span className="text-[#C2410C] shrink-0">·</span>
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {sub.after && (
                    <p className="mt-2.5 font-news text-base text-[#44403C] leading-relaxed">
                      {sub.after}
                    </p>
                  )}
                </div>
              ))}
            </section>
          ))}
        </div>
        <a
          href="/"
          data-testid="privacy-back-link"
          className="mt-14 inline-block font-sans text-sm font-semibold text-[#C2410C] border-b border-[#C2410C] pb-1 hover:text-[#9A3412] transition-colors"
        >
          ← Back to homepage
        </a>
      </div>
    </main>
  );
}
